"use client";
import { useEffect, useRef, useState } from "react";
import Link from "~/components/Link";
import { trackEvent } from "~/connectors/analytics.connector";
import { AnalyticsEvents } from "~/connectors/analyticsEvents";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material/styles";

export default function LyricsStickyFooter() {
  const theme = useTheme();
  const [isVisible, setIsVisible] = useState(false);
  const hasTrackedShown = useRef(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setIsVisible(true);
      }
    };

    // Add scroll listener
    window.addEventListener("scroll", handleScroll, { passive: true });

    // Check initial scroll position
    handleScroll();

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // Track analytics event when footer becomes visible (only once)
  useEffect(() => {
    if (isVisible && !hasTrackedShown.current) {
      trackEvent(AnalyticsEvents.VERSURI_STICKY_FOOTER_SHOWN);
      hasTrackedShown.current = true;
    }
  }, [isVisible]);

  if (!isVisible) {
    return null;
  }

  return (
    <Box
      sx={{
        position: "fixed",
        bottom: 0,
        left: {
          xs: 0,
          sm: 0,
          md: "auto",
        },
        right: 0,
        backgroundColor: "secondary.main",
        color: "secondary.contrastText",
        py: 1.5,
        px: 2,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 2,
        boxShadow: theme.shadows[8],
        zIndex: theme.zIndex.appBar - 1,
      }}
    >
      <Typography
        variant="body2"
        sx={{
          flex: 1,
        }}
      >
        Vrei un cântec cu numele copilului tău?
      </Typography>
      <Link
        button
        trackable={AnalyticsEvents.VERSURI_STICKY_FOOTER_CLICK}
        href="/"
        variant="outlined"
        color="inherit"
        size="small"
        sx={{
          flexShrink: 0,
        }}
      >
        Află cum
      </Link>
    </Box>
  );
}
